document.addEventListener(
  "DOMContentLoaded", () => {
      new Mmenu( "#menu", {
         "offCanvas": {
            "position": "left",
            "page": {
               "selector": "#custom-mm-wrapper"
            }
         },
         "theme": "light",
         "setSelected": {
           "hover": true,
           "parent": true
         },
         "iconPanels": {
            "add": true,
            "visible": 1
          },
         "navbars": [
            {
              "position": "top",
              "content": [
                 "prev",
                 "title"
              ]
            },
            {
               "position": "bottom",
               "content": [
                  "<a class='fa fa-envelope' href='mailto:support@expressgaragedoors.com'></a>",
                  "<a class='fa fa-facebook' href='https://www.facebook.com/expressgaragedoorsinc/'></a>",
                  "<a class='fa fa-instagram' href='https://www.instagram.com/expressgaragedoorsinc/'></a>",
                  "<a class='fa fa-pinterest' href='https://www.pinterest.com/expressgaragedoorsinc/'></a>",
                  "<a class='fa fa-youtube' href='https://www.youtube.com/user/garagedoortutorials'></a>"
               ]
            }
         ]
      });
  }
);
